import { createContext } from "react";

export const AuthContext = createContext(null);
export const PopupContext = createContext(null);
export const SearchContext = createContext("");
